// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-9909e03e]{padding:.5em;margin:1em;max-height:60vh;min-height:20vh;overflow-y:scroll}.card.no-scroll[data-v-9909e03e]{overflow-y:hidden}@media only screen and (min-width:768px){.where-used-card[data-v-9909e03e]{max-height:90vh}}.card:first-of-type .column-item[data-v-9909e03e]:first-of-type{margin-top:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
